import { createStore, RequestControl } from "@mobx/services/http";
import { action, makeObservable, observable } from "mobx";
import { createPlaceStore, PlaceStore } from "./placeStore";
import { PlaceID3 } from "./types";

export interface ConnectionsStore {
  isLoading: boolean;
  editors: Record<number, PlaceStore>;
  getPlaceStore: (placeID: PlaceID3, isLocation?: boolean) => PlaceStore;
  removePlaceStore: (placeID: PlaceID3) => void;
}

const createConnectionsStore_ = (rc: RequestControl): ConnectionsStore => {
  const self: ConnectionsStore = {
    isLoading: false,
    editors: {},

    getPlaceStore(placeID: PlaceID3, isLocation = true) {
      const existing = self.editors[placeID];
      if (existing) {
        if (existing.isLocation !== isLocation) existing.isLocation = isLocation;
        return existing;
      }
      const store = createPlaceStore({ placeID, isLocation, rc });
      self.editors = { ...self.editors, [placeID]: store };
      return store;
    },

    removePlaceStore(placeID: PlaceID3) {
      const store = self.editors[placeID];
      if (store?.isInitializing) return;
      const { [placeID]: _, ...rest } = self.editors;
      self.editors = rest;
    },
  };

  return makeObservable(self, {
    editors: observable,
    getPlaceStore: action,
    removePlaceStore: action,
  });
};

export const createConnectionsStore = () => createStore((rc) => createConnectionsStore_(rc));
const connectionsStore = createConnectionsStore();

export default connectionsStore;
